module.exports = {"meta":{"description":"Yoop es una nueva forma de asistir a eventos","keywords":"música, deportes, boleto, evento, espectáculo, concierto, creadores, aficionados, artista, atletas, equipos, entradas, venta de entradas, asiento, asientos, festival, grupos, juego, en vivo, app"}}


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src891534606/src/modules/web/src/js/i18n/spanish/meta.es.i18n.json
// module id = 1342
// module chunks = 0